import { useState, useMemo } from 'react';
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import { useLanguage } from '../../../../context/LanguageContext';

interface PersonIdsTableProps {
    personIds: number[];
}

function PersonIdsTable({ personIds }: PersonIdsTableProps) {
    const { t } = useLanguage();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const paginated = useMemo(
        () => personIds.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
        [personIds, page, rowsPerPage]
    );

    return (
        <Box>
            <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
                <Table size="small">
                    <TableHead>
                        <TableRow sx={{ bgcolor: 'grey.50' }}>
                            <TableCell sx={{ fontWeight: 700, color: 'text.primary', width: 60 }}>#</TableCell>
                            <TableCell sx={{ fontWeight: 700, color: 'text.primary' }}>{t('pages.clients.queryBuilder.personIdsTable.idPersonColumn')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paginated.length > 0 ? paginated.map((personId, idx) => (
                            <TableRow key={personId} hover sx={{ bgcolor: idx % 2 === 0 ? 'background.paper' : 'grey.50' }}>
                                <TableCell sx={{ color: 'text.secondary', fontWeight: 500 }}>
                                    {page * rowsPerPage + idx + 1}
                                </TableCell>
                                <TableCell sx={{ fontFamily: (t) => t.typography.fontFamilyMono, fontWeight: 600, color: 'primary.main' }}>
                                    {personId}
                                </TableCell>
                            </TableRow>
                        )) : (
                            <TableRow>
                                <TableCell colSpan={2} align="center">
                                    <Typography variant="body2" color="text.secondary">{t('pages.clients.queryBuilder.personIdsTable.noResults')}</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            {personIds.length > rowsPerPage && (
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    component="div"
                    count={personIds.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={(_, newPage) => setPage(newPage)}
                    onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
                    labelRowsPerPage={t('common.rowsPerPage')}
                />
            )}
        </Box>
    );
}

export default PersonIdsTable;
